// PowerFilter 返回菜单操控权限 true可以 false不可以
// 参数  id 菜单自定义标识（用于匹配对应配置信息）
// 返回值 boolean
function PowerFilter(id) {
    let isTrue = false;
    if(localStorage.getItem('menusmd')&&localStorage.getItem('menusmd')!=undefined) {
        let elementInfo = JSON.parse(localStorage.getItem('menusmd'));
        if(elementInfo.includes(id)) {
            isTrue = true;
        }
    }
    return isTrue;
}
export {
    PowerFilter
}


// WEBPACK FOOTER //
// ./src/util/powerFilter.js